import './App.css';
// import ComingSoon from './components/ComingSoon';
import Footer from './components/Footer';
import Navigation from './components/Navigation';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import AreasOfPractice from './pages/AreasOfPractice';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';

const App = () => {
  return (
    // 1. Wrap the application in the Router
    <Router>
      <div className="app-layout">
        
        {/* Navigation is rendered on every page */}
        <Navigation /> 
        <ScrollToTop />
        {/* 2. Define the routing area */}
        <main className="main-content">
          <Routes>
            {/* 3. Define the Route for each path */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/areas-of-practice" element={<AreasOfPractice />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Optional: A route for pages not found (404) */}
            <Route path="*" element={<h1>404: Page Not Found</h1>} />
          </Routes>
        </main>

        {/* Footer is rendered on every page */}
        <Footer />
        
      </div>
    </Router>
  );
};

export default App;